import {getTrialPackageQuantity, setTrialPackageQuantity} from 'helpers/logins'
import {isAccountSubscriptionYearly} from 'helpers/user'
import {get, isNil} from 'lodash'
import {findPackagePartCodeForAccountPackage} from 'helpers/plans'

export const FILE_UPLOAD_CHUNK_SIZE_MB = 10
export const SETTINGS_NAV_HEIGHT = 50

export const RegionalLocale = {
  EN_GB: 'en-gb',
  EN_AU: 'en-au',
  EN_CA: 'en-ca',
  EN_NZ: 'en-nz',
  EN: 'en',
}

export const getAccountPackageParams = (accountPackages, featurePackages) => {
  return accountPackages.map(accountPackage => {
    return {
      partCode: findPackagePartCodeForAccountPackage(featurePackages, accountPackage),
      quantity: accountPackage.quantity,
    }
  })
}

export const getFilteredContactsWithAccountPackages = (contacts, accountPackages) => {
  return contacts
      .filter(contact => contact.activePackages
          .some(activePackage => accountPackages.some(accountPackage => accountPackage.packageId === activePackage.packageId)))
}

export const isSubscriptionUpdateRequiredForTrial = (accountPackages, featurePackages, contacts) => {
  const quantity = getTrialPackageQuantity(featurePackages, accountPackages)
  const filteredContacts = getFilteredContactsWithAccountPackages(Object.values(contacts), accountPackages)
  const numberOfUsers = filteredContacts.length
  return numberOfUsers > quantity
}

export const getSubscriptionParamsForTrial = (user, accountPackages, featurePackages, filteredAccountPackages) => {
  const quantity = getTrialPackageQuantity(featurePackages, filteredAccountPackages)
  const newActivePackages = setTrialPackageQuantity(quantity + 1, user, featurePackages, accountPackages, filteredAccountPackages)
  return {
    isYearly: isAccountSubscriptionYearly(user),
    packages: getAccountPackageParams(newActivePackages, featurePackages),
  }
}

export const getActivityTypeOptions = (activityTypes) => {
  return activityTypes
      .filter(activityType => !isNil(activityType.fixedType) && (activityType.fixedType !== -7 && activityType.itemType !== -7))
      .map(activityType => {
        return {
          id: activityType.itemType,
          value: activityType.itemType,
          key: activityType.itemType,
          label: get(activityType, 'name', null),
          activityType,
        }
      })
}

export const getFilteredAccountPackages = (accountPackages, selectedPackages) => {
  return accountPackages.filter(accountPackage => selectedPackages.some(selectedPackage => selectedPackage.id === accountPackage.packageId))
}

// NOTE: Activity type color palette - these are user-selectable colors
// FLAGGED: 37 color options for activity types - these could be themeable but are primarily
// a fixed color palette for user selection. Consider whether dark mode variants are needed.
export const getActivityTypeColorOptions = () => {
  return [
    {id: 0, value: '#FFFFFF', label: ' '},  // white
    {id: 1, value: '#FFE3F4', label: ' '},  // light pink
    {id: 2, value: '#A8E8FF', label: ' '},  // light blue
    {id: 3, value: '#BDFBB7', label: ' '},  // light green
    {id: 4, value: '#FFFCBD', label: ' '},  // light yellow
    {id: 5, value: '#E5A1FF', label: ' '},  // light purple
    {id: 6, value: '#B0C1FF', label: ' '},  // periwinkle
    {id: 7, value: '#BBD2D1', label: ' '},  // sage
    {id: 8, value: '#FAD4DE', label: ' '},  // blush
    {id: 9, value: '#FCCCB6', label: ' '},  // peach
    {id: 10, value: '#EBE1B3', label: ' '}, // cream
    {id: 11, value: '#E6CAD9', label: ' '}, // mauve
    {id: 12, value: '#97D7DD', label: ' '}, // powder blue
    {id: 13, value: '#C7A0C4', label: ' '}, // lilac
    {id: 14, value: '#F2F4A1', label: ' '}, // pale yellow
    {id: 15, value: '#D4E6EE', label: ' '}, // sky blue
    {id: 16, value: '#F6A3B8', label: ' '}, // rose
    {id: 17, value: '#FFAC9F', label: ' '}, // coral
    {id: 18, value: '#FDD1C2', label: ' '}, // apricot
    {id: 19, value: '#FDFAD5', label: ' '}, // pale cream
    {id: 20, value: '#E8BAC3', label: ' '}, // dusty rose
    {id: 21, value: '#00C6C4', label: ' '}, // teal
    {id: 22, value: '#B0D2F2', label: ' '}, // baby blue
    {id: 23, value: '#8DA5F3', label: ' '}, // periwinkle blue
    {id: 24, value: '#D59FE8', label: ' '}, // orchid
    {id: 25, value: '#E0DBD8', label: ' '}, // warm gray
    {id: 26, value: '#EBB7D2', label: ' '}, // pink
    {id: 27, value: '#D0E7E6', label: ' '}, // mint
    {id: 28, value: '#7AC2C3', label: ' '}, // seafoam
    {id: 29, value: '#C1DAC1', label: ' '}, // sage green
    {id: 30, value: '#CFEAD9', label: ' '}, // light mint
    {id: 31, value: '#83BB9F', label: ' '}, // jade
    {id: 32, value: '#FFBE96', label: ' '}, // cantaloupe
    {id: 33, value: '#FCCDB1', label: ' '}, // light peach
    {id: 34, value: '#F0BCB9', label: ' '}, // salmon
    {id: 35, value: '#EEAAA6', label: ' '}, // terra cotta
    {id: 36, value: '#F39991', label: ' '}, // melon
  ]
}
